


import SECTION_ESPORTGAMEBANNERSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_ESPORTGAMECONTAINERSECTION from
'../dynamic_section/dynamic_1/template_01';





import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const EsportPageDesktop = ()=>{
return (
  <div id="esportPageDesktop" class="page ">
  
  

  
  < SECTION_ESPORTGAMEBANNERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `esport_game_banner` } id={ `esport_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  < SECTION_ESPORTGAMECONTAINERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `Section_sport_game` } id={ `esportGameContainer` }
    imageSize={`2x1`} contentPosition={`bottom`}
    actionPosition={``} rowDesktop={ 7 }
    rowMobile={ 3 } numberOfRow={ -1 }
    dataType={`game provider`} noPadding={ false } filter={`ES`}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={`start`} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
</div>
)
}

export default EsportPageDesktop;